import { configure as configureMobx } from 'mobx';
import { createRoot } from 'react-dom/client';

import { Site } from './components/Site/Site';
import { Spinner } from './components/Spinner/Spinner';
import { isLocalDevelopment } from './constants';
import { t } from './i18n';
import { promoteConsoleErrors } from './logging/consoleLogs';
import { setupDayjs } from './utilities/setupDayjs';

const rootContainer = document.getElementById('react-app');
const headerContainer = document.getElementById('react-header');
export const rootElement = createRoot(rootContainer);
export const headerElement = createRoot(headerContainer);

export const setupCommonConfigurations = () => {
	setupDayjs();
	configureMobx({
		enforceActions: 'observed',

		// Feel free to turn these on during new, local development, but our site has many many warnings and turning these on by default will clutter the console too much.
		// computedRequiresReaction: true,
		// reactionRequiresObservable: true
		// observableRequiresReaction: true
	});

	if (isLocalDevelopment || window.__$pw) {
		promoteConsoleErrors();
	}
};

export const SiteSpinner = ({ title }: { title: string }) => {
	return (
		<Site>
			<Spinner size="huge" label={t('LoadingMessage', { microsoftTitle: title })} />
		</Site>
	);
};
